import { render, staticRenderFns } from "./Conferimenti.vue?vue&type=template&id=781ffe70&"
import script from "./Conferimenti.vue?vue&type=script&lang=js&"
export * from "./Conferimenti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports